import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n-lite';
import { AnnotationTypeIcon, ANNOTATION_TYPE_COLORS, HowToList } from '@netexknowledge/smart-components';
import { ANNOTATION_SHORTCUTS, READER_ACTION_COLOR } from './annotationTypes';
import { translateWithTokens as translateWithTokensBase } from '../../../services/translate/translateWithTokens';

const readerActionIcon = type => <AnnotationTypeIcon type={type} size={15} color={READER_ACTION_COLOR} />;

/**
 * Nodes that replace the %{…} placeholders of the help texts: the reader buttons and the tool name.
 */
export const getHelpTokens = () => ({
  highlightIcon: readerActionIcon('highlight'),
  unhighlightIcon: readerActionIcon('unhighlight'),
  textNoteIcon: readerActionIcon('textNote'),
  noteTool: <strong>{I18n.t('annotations.help.note.tool')}</strong>
});

export const translateWithTokens = (key, tokens = getHelpTokens()) => translateWithTokensBase(key, tokens);

export const getHelpItems = () => {
  const keyboard = I18n.t('annotations.help.keyboard');
  return [
    {
      key: 'highlight',
      icon: <AnnotationTypeIcon type="highlight" color={ANNOTATION_TYPE_COLORS.highlight.icon} />,
      iconBackground: ANNOTATION_TYPE_COLORS.highlight.background,
      title: I18n.t('annotations.help.highlight.title'),
      description: translateWithTokens('annotations.help.highlight.description'),
      shortcuts: [
        { label: keyboard, keys: ANNOTATION_SHORTCUTS.highlight },
        { label: I18n.t('annotations.help.remove'), keys: ANNOTATION_SHORTCUTS.unhighlight }
      ]
    },
    {
      key: 'textNote',
      icon: <AnnotationTypeIcon type="textNote" color={ANNOTATION_TYPE_COLORS.textNote.icon} />,
      iconBackground: ANNOTATION_TYPE_COLORS.textNote.background,
      title: I18n.t('annotations.help.textNote.title'),
      description: translateWithTokens('annotations.help.textNote.description'),
      shortcuts: [{ label: keyboard, keys: ANNOTATION_SHORTCUTS.textNote }]
    },
    {
      key: 'note',
      icon: <AnnotationTypeIcon type="note" color={ANNOTATION_TYPE_COLORS.note.icon} />,
      iconBackground: ANNOTATION_TYPE_COLORS.note.background,
      title: I18n.t('annotations.help.note.title'),
      description: translateWithTokens('annotations.help.note.description')
    }
  ];
};

/**
 * How to create each kind of annotation. Shared by the empty state (framed) and the help popover (compact).
 */
export default function AnnotationsHelp({ compact, framed }) {
  return <HowToList items={getHelpItems()} compact={compact} framed={framed} />;
}

AnnotationsHelp.propTypes = {
  compact: PropTypes.bool,
  framed: PropTypes.bool
};
